import { render, staticRenderFns } from "./icon-rotate.vue?vue&type=template&id=5986734e&scoped=true&"
import script from "./icon-rotate.vue?vue&type=script&lang=js&"
export * from "./icon-rotate.vue?vue&type=script&lang=js&"
import style0 from "./icon-rotate.vue?vue&type=style&index=0&id=5986734e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5986734e",
  null
  
)

export default component.exports